<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div class="cover" epub:type="cover" id="_idContainer000">
<img alt="cover image" class="_idGenObjectAttribute-1" src="image/9780738771670.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Cover.vue?bcea9cfe